import { render, staticRenderFns } from "./administrationAgentInfoDetails.vue?vue&type=template&id=64f5f6be&scoped=true&"
import script from "./administrationAgentInfoDetails.vue?vue&type=script&lang=js&"
export * from "./administrationAgentInfoDetails.vue?vue&type=script&lang=js&"
import style0 from "./administrationAgentInfoDetails.vue?vue&type=style&index=0&id=64f5f6be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f5f6be",
  null
  
)

export default component.exports